import { addHours, format } from "date-fns"
import { Button } from "primereact/button"
import { Dialog } from "primereact/dialog"
import React from "react"
import { FaDownload, FaFilePdf } from "react-icons/fa"
import Base64ToPDF from "../../../utils/Base64ToPDF"

function EndingDialog({negotiationInfo,close}){

    const footer= (
        <div className="flex justify-center gap-2 w-full">
            <Button
            label={" Baixar 1º Boleto"}
            onClick={()=>{baixaBoleto()}}
            //loading={loading}
            //disabled={valorAPagar === 0}
            className="w-full lg:w-1/2 xl:w-1/3"
            icon={<FaDownload className="mr-2"/>}
            />
            <Button 
                label=" Baixar Termo" 
                className="w-full lg:w-1/2 xl:w-1/3"
                severity="danger" 
                icon={<FaFilePdf className="mr-2"/>} 
                //disabled={valorTotal === 0}
                onClick={()=>Base64ToPDF(negotiationInfo.termoBase64,`Termo_${format(new Date(),'dd-MM-yyyy')}`)}
            />
        </div>  
    )

    function baixaBoleto(){
        //console.log(negotiationInfo)
        Base64ToPDF(negotiationInfo.boletoData.boleto_base64,`boleto-vencimento:${format(
            addHours(new Date(negotiationInfo.boletoData.boleto_vencimento),3),
            "dd/MM/yyyy")}`)
    }

    return(
        <Dialog
        visible
        onHide={()=>close()}
        header="Negociação Gerada com Sucesso"
        footer={footer}
        >
            <div className="text-center flex flex-col text-lg">
                <h4><b>Você pode fazer o download do termo e do primeiro boleto abaixo</b></h4>
            </div>
        </Dialog>
    )
}

export default EndingDialog